import React from 'react';
import { TrendingUp, TrendingDown, DollarSign, CreditCard, Wallet } from 'lucide-react';

const iconMap = {
  TrendingUp,
  TrendingDown,
  DollarSign,
  CreditCard,
  Wallet
};

const KPICard = ({ title, value, change, trend, icon, color }) => {
  const IconComponent = iconMap?.[icon] || DollarSign;
  
  return (
    <div className="bg-white border border-gray-200 rounded-lg p-6 shadow-sm hover:shadow-md transition-shadow">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-sm font-medium text-gray-600">{title}</h3>
        <div 
          className="p-2 rounded-lg"
          style={{ backgroundColor: `${color}20` }}
        >
          <IconComponent 
            className="w-5 h-5" 
            style={{ color: color }}
          />
        </div>
      </div>
      
      <div className="mb-2">
        <p className="text-2xl font-bold text-gray-900">{value}</p>
      </div>
      
      <div className="flex items-center gap-2">
        <span className="text-sm text-gray-500">{change}</span>
        {trend === 'up' && (
          <TrendingUp className="w-4 h-4 text-green-500" />
        )}
        {trend === 'down' && (
          <TrendingDown className="w-4 h-4 text-red-500" />
        )}
      </div>
    </div>
  );
};

export default KPICard;